<template>
  <nav class="user-info__menu">
    <h1 class="logo">
      <router-link :to="{name: 'dashboard'}">
        <i class="icon icon--logo-red"></i>
      </router-link>
    </h1>
    <ul class="menu-list">
      <li class="list" v-for="item in MenuList" :key="item">
        <router-link class="item" :class="{on: item === routeName}" :to="{name: `${item}`}">{{ $t(`userInfo.lnb.${item}`) }}</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: [
    'routeName'
  ],
  computed: {
    ...mapState([
      'userData'
    ]),
    MenuList () {
      if (this.userData.isGmc) {
        return [
          'managePlan',
          'requestManagement',
          'userManagement',
          'pageManagement',
          'myInformation',
          'ipBlocking'
        ]
      } else {
        return [
          'myInformation',
          'ipBlocking'
        ]
      }
    }
  },
  methods: {
    showCouponLayer () {
      this.$emit('showCouponLayer')
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.user-info__menu {
  .menu-list {
    margin-top: 100px;

    .list:first-child .item {
      border-top: 1px solid #ebebeb;
    }

    .item {
      display: block;
      padding: 18px 12px;
      font-size: 13px;
      font-weight: bold;
      color: #2f2f2f;
      border-bottom: 1px solid #ebebeb;

      &.on {
        color: $brandColor;
      }
    }
  }
  .btn__coupon {
    width: 186px;
    height: 38px;
    border-radius: 20px;
    border: solid 1px #bbbbbb;
    background-color: #ffffff;
    position: absolute;
    left: 12px;
    bottom: 12px;
    text-align: right;

    /deep/ .icon {
      position: absolute;
      top: 50%;
      left: 12px;
      transform: translateY(-50%);
    }
  }
}
</style>
